import React, { useEffect, useState, useMemo } from "react";
import { Table } from "antd";
import axios from "axios";
import { schemeColumns } from "../columns/schemeColumns";
import { LedgerResponsiveWrapper, API_BASE, getArn, rowMatchesSearch } from "../LedgerResponsive";

export default function SchemeTable({ folio, pan, onOpenModal, onDrillScheme, searchQuery }) {
  const [schemes, setSchemes] = useState([]); const [loading, setLoading] = useState(false);
  useEffect(() => { if (!folio || !pan) return; setLoading(true);
    axios.get(`${API_BASE}/get_schemes.php?folio_number=${folio}&pan=${pan}&arn_no=${getArn()}`)
      .then((res) => setSchemes(res.data && Array.isArray(res.data.schemes) ? res.data.schemes : []))
      .catch(() => setSchemes([])).finally(() => setLoading(false));
  }, [folio, pan]);
  const filtered = useMemo(() => schemes.filter(r => rowMatchesSearch(r, searchQuery)), [schemes, searchQuery]);
  return <LedgerResponsiveWrapper><Table loading={loading} columns={schemeColumns(onOpenModal)} dataSource={filtered}
    rowKey="scheme_code" pagination={false} bordered sticky scroll={{x:"max-content"}} tableLayout="auto"
    onRow={(record)=>({onClick:(e)=>{if(e.target.closest("button,a,[role='button']"))return;onDrillScheme?.(record);},style:{cursor:"pointer"}})} /></LedgerResponsiveWrapper>;
}
